import { render } from "./ReturnHomeButton.vue?vue&type=template&id=89e8012e"
import script from "./ReturnHomeButton.vue?vue&type=script&lang=js"
export * from "./ReturnHomeButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/logexpo/logexpo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
